import React from 'react';
import { Divider } from '@material-ui/core';

const MissingPalletDetailCell = ({ row }) => {
    const expectedResults = row?.expectedResults || [];
    const fromLocationEmptyModal = row?.metadata?.fromLocationEmpty;
    const palletId = expectedResults[0]?.expectedPalletID;

    return (
        <div style={{ margin: '10px 0px' }}>
            <div style={{ textDecoration: 'underline', textAlign: 'center', fontWeight: 'bold' }}>
                <div>Pallet {palletId} Moved To Missing</div>
            </div>
            {fromLocationEmptyModal && <div style={{ fontWeight: 'bold' }}>From Location Empty</div>}

            {expectedResults.map((result, index) => (
                <div key={result?.expectedResultID || index}>
                    {index > 0 && <Divider variant="middle" style={{ margin: '5px' }} />}
                    <div>
                        <strong>Item: </strong>
                        {result?.itemName}
                    </div>
                    <div>
                        <strong>Lot: </strong>
                        {result?.expectedLotID}
                        <strong> Sku: </strong>
                        {row?.externalSku}
                    </div>
                    <div>
                        <strong>Units Moved: </strong>
                        {result?.totalExpectedUnits} units ({result?.expectedCaseCount} cases,{' '}
                        {result?.expectedLooseUnitCount} loose units)
                    </div>
                </div>
            ))}
        </div>
    );
};

export { MissingPalletDetailCell };
